import useWindowsSize from './windowsresize'
import HomeButtons from './home/buttons'
import BarChart from './home/barchart'
import SurgeonTable from './surgeon/surgeon.table'
import UserTable from './user/user.table'
import PatientTable from './patient/patient.table'
import PatientFilter from './patient/patient.filter'
import PatientAction from './patient/patient.notify'
import PatientInfoForm from './patient/patient.info.form'
import PatientInfo from './patient/patient.info'
import PatientCalendar from './patient/patient.calendar'
import PatientEvents from './patient/patient.events'
import PatientButtons from './patient/patient.buttons'
import PatientRegForm from './regimen/regimen.form'
import PatientForms from './patient/forms'
import PrivateRoute from './route/private'
import CarePlan from './devices/device.form'
import EditDeviceForm from './devices/device.edit'
import moment from 'moment'
import ScheduleForm from './schedule/schedule.form'
import ScheduleList from './schedule/schedule.list'
import CustomerTable from './customer/customer.table'
import CustomerFilter from './customer/customer.filter'
import CustomerAction from './customer/customer.action'
import CompanyTable from './company/company.table'
import CompanyAction from './company/company.action'
import CompanyFilter from './company/company.filter'
import MessageTable from './message/message.table'
import MessageAction from './message/message.action'
import MessageFilter from './message/message.filter'
import SurgeonList from './message/message.surgeons'
import EventAction from './event/event.action'
import EventList from './event/event.list'
import EventDrawer from './event/event.drawer'
import HCCustomerTable from './healthcoach/healthcoach.table'
import FeedbackForm from './feedback/feedback'
import FullfilmentFilter from '../pages/fullfillment/fullfilment.filter'
import FullfilmentFilterlist from '../pages/fullfillment/fullfilment.filterlist'
import { CHART_COLORS } from '../util/chartPalette'

const GraphData = [
  { date: moment().add('d', 1), count: 90, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 3), count: 80, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 2), count: 70, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 4), count: 60, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 5), count: 50, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 6), count: 40, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 7), count: 30, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 8), count: 21, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 9), count: 10, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 10), count: 5, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 11), count: 50, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 12), count: 40, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 13), count: 30, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 14), count: 21, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 15), count: 10, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 16), count: 5, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 17), count: 80, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 18), count: 50, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 19), count: 5, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 20), count: 50, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 22), count: 40, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 23), count: 30, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 24), count: 21, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 25), count: 10, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 26), count: 5, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 27), count: 80, color: CHART_COLORS.lineBlue },
  { date: moment().add('d', 28), count: 50, color: CHART_COLORS.lineBlue },
]

var Home = {
  Buttons: HomeButtons,
  GraphData,
  BarChart,
}

var Surgeon = {
  Table: SurgeonTable,
}

var User = {
  Table: UserTable,
}

var Patient = {
  Table: PatientTable,
  Filter: PatientFilter,
  ActionBar: PatientAction,
  Info: PatientInfo,
  Calendar: PatientCalendar,
  Buttons: PatientButtons,
  Forms: PatientForms,
  Events: PatientEvents,
}

var Fullfillment = {
  Filter: FullfilmentFilter,
  Filterlist: FullfilmentFilterlist,
}

var PatientAdd = {
  InfoForm: PatientInfoForm,
  CarePlanForm: CarePlan,
  RegimenForm: PatientRegForm,
  ScheduleForm: ScheduleForm,
  EditDeviceForm: EditDeviceForm,
  FeedbackForm: FeedbackForm,
}

var Schedule = {
  List: ScheduleList,
}

var Customer = {
  Table: CustomerTable,
  ActionBar: CustomerAction,
  Filter: CustomerFilter,
}

var Message = {
  Table: MessageTable,
  ActionBar: MessageAction,
  Filter: MessageFilter,
  Surgeons: SurgeonList,
}

var Company = {
  Table: CompanyTable,
  ActionBar: CompanyAction,
  Filter: CompanyFilter,
}

var Event = {
  ActionBar: EventAction,
  List: EventList,
  Drawer: EventDrawer,
}

var HealthCoach = {
  Table: HCCustomerTable,
}

export {
  useWindowsSize,
  Home,
  Surgeon,
  User,
  Patient,
  PrivateRoute,
  PatientAdd,
  Schedule,
  Customer,
  Company,
  Message,
  Event,
  HealthCoach,
  Fullfillment,
}
